<!-- Enhanced Pagination HTML -->
<div
  [ngClass]="[paddingXAxis, paddingYAxis, forceStack ? 'flex-col gap-2' : 'flex-col lg:flex-row']"
  class="flex items-center justify-between font-normal gap-1 sm:gap-1.5 md:gap-2 dark:text-slate-400 w-full"
>
  <!-- Left: Showing count with icon -->
  <div [ngClass]="forceStack ? 'flex' : 'hidden md:flex'" class="items-center gap-1 md:gap-1.5 text-xs sm:text-sm text-gray-600">
    <span class="font-normal dark:text-slate-400">
      Showing <span>{{ startItem }}</span> to <span>{{ endItem }}</span> of
      <span>{{ displayTotalItems }}</span> items
    </span>
  </div>

  <!-- Center/Right: Pagination Controls -->
  <div class="flex items-center justify-center gap-0 sm:gap-0.5 md:gap-1">
    <!-- First Page Button -->
    <button
      class="p-0.5 sm:p-1 md:p-1.5 text-sm rounded-lg transition-all duration-200 cursor-pointer"
      [ngClass]="{
        'border-none text-slate-400 dark:text-gray-600 cursor-not-allowed':
          currentPage === 1,
        'border-none text-slate-800 dark:text-ink-muted dark:hover:bg-surface-3 hover:bg-[#f3e8ff] hover:text-[#960ef7] transistion-all duration-500':
          currentPage !== 1
      }"
      [disabled]="currentPage === 1"
      (click)="changePage(1)"
      aria-label="Go to first page"
    >
      <app-icon [size]="16" class="sm:hidden" name="ChevronsLeft"></app-icon>
      <app-icon [size]="18" class="hidden sm:block md:hidden" name="ChevronsLeft"></app-icon>
      <app-icon [size]="20" class="hidden md:block" name="ChevronsLeft"></app-icon>
    </button>

    <!-- Previous Button -->
    <button
      class="p-0.5 sm:p-1 md:p-1.5 text-sm rounded-lg transition-all duration-200 cursor-pointer"
      [ngClass]="{
        'border-none text-slate-400 dark:text-gray-600 cursor-not-allowed':
          currentPage === 1,
        'border-none text-slate-800 dark:text-ink-muted dark:hover:bg-surface-3 hover:bg-[#f3e8ff] hover:text-[#960ef7] transistion-all duration-500':
          currentPage !== 1
      }"
      [disabled]="currentPage === 1"
      (click)="changePage(currentPage - 1)"
      aria-label="Go to previous page"
    >
      <div class="flex items-center gap-1">
        <app-icon [size]="16" class="sm:hidden" name="ChevronLeft"></app-icon>
        <app-icon [size]="18" class="hidden sm:block md:hidden" name="ChevronLeft"></app-icon>
        <app-icon [size]="20" class="hidden md:block" name="ChevronLeft"></app-icon>
      </div>
    </button>

    <!-- Page Numbers -->
    <div class="flex items-center gap-0.5">
      @for(page of getDisplayedPages(); track $index){
      <ng-container>
        @if (page !== '...') {
        <button
          class="flex items-center justify-center min-w-5 sm:min-w-6 md:min-w-7 h-5 sm:h-6 md:h-7 p-0.5 sm:p-1 md:p-1.5 text-xs sm:text-sm rounded-lg transition-all duration-200 cursor-pointer"
          [ngClass]="{
            'bg-[#AD46FF] from-purple-600 to-indigo-600 hover:from-purple-500 hover:to-indigo-500 text-white shadow-purple-500/30':
              currentPage === page,
            'text-[#7D7D93] dark:text-ink-muted border-gray-300 dark:hover:bg-surface-3 hover:bg-[#f3e8ff] hover:text-[#960ef7] transistion-all duration-500':
              currentPage !== page
          }"
          (click)="changePage(page)"
          [attr.aria-label]="'Go to page ' + page"
          [attr.aria-current]="currentPage === page ? 'page' : null"
        >
          {{ page }}
        </button>
        }
      </ng-container>
      }
    </div>

    <!-- Next Button -->
    <button
      class="p-0.5 sm:p-1 md:p-1.5 text-sm rounded-lg transition-all duration-200 cursor-pointer"
      [ngClass]="{
        'border-none text-slate-400 dark:text-gray-600 cursor-not-allowed':
          currentPage === totalPages,
        'border-none text-slate-800 dark:text-ink-muted dark:hover:bg-surface-3 hover:bg-[#f3e8ff] hover:text-[#960ef7] transistion-all duration-500':
          currentPage !== totalPages
      }"
      [disabled]="currentPage === totalPages"
      (click)="changePage(currentPage + 1)"
      aria-label="Go to next page"
    >
      <div class="flex items-center gap-1">
        <app-icon [size]="16" class="sm:hidden" name="ChevronRight"></app-icon>
        <app-icon [size]="18" class="hidden sm:block md:hidden" name="ChevronRight"></app-icon>
        <app-icon [size]="20" class="hidden md:block" name="ChevronRight"></app-icon>
      </div>
    </button>

    <!-- Last Page Button -->
    <button
      class="p-0.5 sm:p-1 md:p-1.5 text-sm rounded-lg transition-all duration-200 cursor-pointer"
      [ngClass]="{
        'border-none text-slate-400 dark:text-gray-600 cursor-not-allowed':
          currentPage === totalPages,
        'border-none text-slate-800 dark:text-ink-muted dark:hover:bg-surface-3 hover:bg-[#f3e8ff] hover:text-[#960ef7] transistion-all duration-500':
          currentPage !== totalPages
      }"
      [disabled]="currentPage === totalPages"
      (click)="changePage(totalPages)"
      aria-label="Go to last page"
    >
      <app-icon [size]="16" class="sm:hidden" name="ChevronsRight"></app-icon>
      <app-icon [size]="18" class="hidden sm:block md:hidden" name="ChevronsRight"></app-icon>
      <app-icon [size]="20" class="hidden md:block" name="ChevronsRight"></app-icon>
    </button>
  </div>
</div>
